// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v2.CappsLandlordApplicationPermissionsV2WebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck,
  CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck_Path,
} from '@zg-rentals/ts-capps-client';

import type { ListingAlias, PermissionCheckV2WebApiDto } from '@zg-rentals/ts-capps-client';

interface PermissionCheckParams {
  listingAlias: ListingAlias;
}

export type CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck_Options = UseQueryOptions<
  PermissionCheckV2WebApiDto,
  unknown,
  PermissionCheckV2WebApiDto,
  readonly [string, PermissionCheckParams]
>;

const CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck_GetKey = (getParams: PermissionCheckParams) =>
  [CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck_Path, getParams] as const;

export const CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck_queryOptions = (
  getParams: PermissionCheckParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck_GetKey(getParams),
    queryFn: () => CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck = (
  getParams: PermissionCheckParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck.getKey =
  CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck_GetKey;
